import { render, staticRenderFns } from "./SettingsProductsCreate.vue?vue&type=template&id=5247fb1a&scoped=true&"
import script from "./SettingsProductsCreate.vue?vue&type=script&lang=js&"
export * from "./SettingsProductsCreate.vue?vue&type=script&lang=js&"
import style0 from "./SettingsProductsCreate.vue?vue&type=style&index=0&id=5247fb1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5247fb1a",
  null
  
)

export default component.exports